import React from "react";

import { WorkTypeStatusesSectionProps } from "../model/workTypeEditor.types";
import { StatusesCard } from "./StatusesCard";

export const WorkTypeStatusesSection: React.FC<
  WorkTypeStatusesSectionProps
> = ({
  isVisible,
  workTypeId,
  visibleServiceStatuses,
  statuses,
  workTypeStatuses,
  isLoadingStatuses,
  setWorkTypeStatuses,
  getStatuses,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={"rounded-md border border-gray-200 bg-white p-4"}>
      <div className={"mb-4 text-lg font-medium"}>Assigned Statuses</div>
      <div className={"grid grid-cols-4 gap-4"}>
        {visibleServiceStatuses.map((item) => (
          <StatusesCard
            key={item.id}
            status={item}
            allStatuses={statuses}
            workTypeStatus={workTypeStatuses.find(
              (i) => i.workTypeStatusId === item.workTypeStatusId,
            )}
            isLoadingStatuses={isLoadingStatuses}
            setWorkTypeStatuses={setWorkTypeStatuses}
            getStatuses={getStatuses}
            workTypeId={workTypeId}
          />
        ))}
      </div>
    </div>
  );
};
